import { useState } from "react";
import ContainerSize from "../../../Components/container";
import SEO from "../../../Components/SEO";

const Videos = () => {
    const videos = [
        { url: "https://youtu.be/5FoLHMcUfpg?feature=shared" },
        { url: "https://youtube.com/shorts/U2pIOINS-jM?feature=shared" },
        { url: "https://youtube.com/shorts/z14M2R7CnWg?feature=shared" },
        { url: "https://youtube.com/shorts/LHLCjtOYF8E?feature=shared" },
        { url: "https://youtube.com/shorts/GobFKy33cMM?feature=shared" },
        { url: "https://youtube.com/shorts/kO_TLkBYsUg?feature=shared" },
        { url: "https://youtube.com/shorts/XQV9nxTtrI0?feature=shared" },
        { url: "https://youtube.com/shorts/Uo_dac0PqWA?feature=shared" },
        { url: "https://youtube.com/shorts/RDgi-B5jQHQ?feature=shared" }
    ];

    const getEmbedUrl = (url, autoplay = false) => {
        let id = "";
        if (url.includes("shorts/")) {
            id = url.split("shorts/")[1].split("?")[0];
        } else if (url.includes("youtu.be/")) {
            id = url.split("youtu.be/")[1].split("?")[0];
        }
        return `https://www.youtube.com/embed/${id}?rel=0&autoplay=${autoplay ? 1 : 0
            }&mute=0&loop=0&playlist=${id}`;
    };

    const [playingIndex, setPlayingIndex] = useState(null);

    const handleClick = (index) => {
        setPlayingIndex(index);
    };

    return (
        <>
        <SEO title="Insurance Outsourcing Videos | imash insure" description="Watch videos on insurance outsourcing, back-office operations, virtual assistants, and workflow solutions for U.S. insurance agencies." />
        <ContainerSize>
  <div className="pl-6 pr-6 ">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 pb-[100px]">
                {videos.map((link, index) => (
                    <div
                        key={index}
                        className="relative aspect-video rounded-lg overflow-hidden shadow-lg bg-black cursor-pointer"
                        onClick={() => handleClick(index)}
                    >
                        {playingIndex === index ? (
                            <iframe
                                className="w-full h-full"
                                src={getEmbedUrl(link.url, true)}
                                title={`YouTube Video ${index + 1}`}
                                frameBorder="0"
                                allow="autoplay; encrypted-media"
                                allowFullScreen
                            ></iframe>
                        ) : (
                            <>
                                <img
                                    src={`https://img.youtube.com/vi/${link.url.includes("shorts/")
                                            ? link.url.split("shorts/")[1].split("?")[0]
                                            : link.url.split("youtu.be/")[1].split("?")[0]
                                        }/hqdefault.jpg`}
                                    alt={`Thumbnail ${index + 1}`}
                                    className="w-full h-full object-cover"
                                />
                              
                                <div className="absolute inset-0 flex items-center justify-center bg-black/40">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-16 h-16 text-white drop-shadow-lg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                    >
                                        <path d="M8 5v14l11-7z" />
                                    </svg>
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
        </ContainerSize>
        </>
        
      
    );
};

export default Videos;
